export function getNewCoordinates(oldCoordinates, distance, heading) {
    const distanceLat = distance * Math.cos(heading * Math.PI / 180);
    const distanceLong = distance * Math.sin(heading * Math.PI / 180);
    const newLat = oldCoordinates.lat + distanceLat / 60;
    const newLong = oldCoordinates.long + distanceLong / (Math.cos(newLat * Math.PI / 180) * 60);
    return {lat: newLat, long: newLong};
}

export function getHeading(a, b) {
    const distanceLat = (b.lat - a.lat) * 60;
    const distanceLong = (b.long - a.long) * Math.cos(a.lat * Math.PI / 180) * 60;

    const heading = Math.atan2(distanceLong, distanceLat) * 180 / Math.PI;
    return Math.round((heading + 360) % 360);
}

export function inverseHeading(heading) {
    return (heading + 180) % 360;
}

export function addVectors(vectorA, vectorB) {
    const vectorAxy = {
        x: vectorA.speed * Math.cos(vectorA.heading * Math.PI / 180),
        y: vectorA.speed * Math.sin(vectorA.heading * Math.PI / 180)
    };
    const vectorBxy = {
        x: vectorB.speed * Math.cos(vectorB.heading * Math.PI / 180),
        y: vectorB.speed * Math.sin(vectorB.heading * Math.PI / 180)
    };

    const vectorSum = {
        x: vectorAxy.x + vectorBxy.x,
        y: vectorAxy.y + vectorBxy.y
    };

    const speed = Math.sqrt(Math.pow(vectorSum.x, 2) + Math.pow(vectorSum.y, 2));
    const heading = Math.atan2(vectorSum.y, vectorSum.x) * 180 / Math.PI;
    return {heading: Math.round((heading + 360) % 360), speed: Math.round(speed)};
}

export function getHeadTailWind(heading, wind) {
    return wind.speed * Math.cos(headingDiff(heading, wind.heading) * Math.PI / 180);
}

export function headingDiff(a, b) {
    const diff = b - a;
    if (diff >= 180) {
        return diff - 360;
    } else if (diff < -180) {
        return diff + 360;
    }
    return diff;
}

export function addHeading(a, b) {
    return (a + b + 360) % 360;
}

export function getDistance(a, b) {
    const distanceLat = (b.lat - a.lat) * 60;
    const distanceLong = (b.long - a.long) * Math.cos(a.lat * Math.PI / 180) * 60;
    return Math.sqrt(Math.pow(distanceLat, 2) + Math.pow(distanceLong, 2));
}

export function getDistanceToTrack(currentPosition, trackStart, trackEnd) {
    const AB = getDistance(trackStart, trackEnd);
    const AC = getDistance(currentPosition, trackStart);
    const BC = getDistance(currentPosition, trackEnd);

    if (Math.abs(AB - AC - BC) < 0.1) { // on the track
        return 0;
    } else if (Math.abs(AC - AB - BC) < 0.1 || Math.abs(BC - AC - AB) < 0.1) { // on the extended track
        return 0;
    } else {
        const alpha = Math.acos((Math.pow(AC, 2) + Math.pow(AB, 2) - Math.pow(BC, 2)) / (2 * AC * AB));
        return AC * Math.sin(alpha);
    }
}

export function getRunwayHeading(runway) {
    return parseInt(runway.replace(/[A-Z]/g, '')) * 10;
}

export function getDownwindWaypoints(airportWp, runway, circuitDirection) {
    const runwayHeading = getRunwayHeading(runway);
    const circuitDirectionMultiplier = circuitDirection.toUpperCase().startsWith('L') ? -1 : 1;
    const downwindStartWp = getNewCoordinates(airportWp, 2, runwayHeading + 45 * circuitDirectionMultiplier);
    const downwindEndWp = getNewCoordinates(airportWp, 2, inverseHeading(runwayHeading) - 45 * circuitDirectionMultiplier);
    return [downwindStartWp, downwindEndWp];
}